import { Phone, Mail } from "lucide-react";

export function TopBar({ isScrolled }) {
  return (
    <div
      className={`bg-[#0E0A06] text-white/60 text-[11px] tracking-wide transition-all duration-500 overflow-hidden ${
        isScrolled ? "h-0 opacity-0" : "h-10 opacity-100"
      }`}
      data-testid="top-bar"
    >
      <div className="container-hh h-full flex items-center justify-between">
        <div className="flex items-center gap-6">
          <a href="tel:+33767484313" className="flex items-center gap-2 hover:text-[#C9922A] transition-colors duration-300" data-testid="top-bar-phone">
            <Phone className="w-3 h-3 text-[#C9922A]/60" />
            <span>+33 7 67 48 43 13</span>
          </a>
          <span className="w-px h-3 bg-white/10 hidden sm:block" />
          <a href="mailto:contact@happyhouse-conciergerie.fr" className="hidden sm:flex items-center gap-2 hover:text-[#C9922A] transition-colors duration-300" data-testid="top-bar-email">
            <Mail className="w-3 h-3 text-[#C9922A]/60" />
            <span>contact@happyhouse-conciergerie.fr</span>
          </a>
        </div>
        <div className="flex items-center gap-4">
          <span className="hidden md:inline text-white/30">Conciergerie & Location — Limoges</span>
          <span className="w-px h-3 bg-white/10 hidden md:block" />
          <div className="flex items-center gap-3">
          </div>
        </div>
      </div>
    </div>
  );
}
